import React from 'react';
import Banner from '../../components/Banner';
import Navbar from '../../components/Navbar';
import StocksPrice from '../../components/Stocks/StocksPrice';

function StockPrices() {
    return (
        <div>
            <Banner />
            <Navbar />
            <StocksPrice />
        </div>
    )
}

export default StockPrices